import { Component } from "@angular/core";
import { BaseListComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-list.component";
import { ZonePriceAnnouncementFormComponent } from "../zone-price-announcement-form/zone-price-announcement-form.component";
import { GridFilter } from "projects/sepidz-web-framework/src/lib/services";

@Component({
  selector: "app-zone-price-announcement-list",
  templateUrl: "./zone-price-announcement-list.component.html",
  styleUrls: ["./zone-price-announcement-list.component.scss"],
})
export class ZonePriceAnnouncementListComponent extends BaseListComponent {
  unSortableFilterable: string[] = [];
  isEdit: boolean = false;
  isDelete: boolean = false;
  filters: GridFilter[] = [
    {
      Filed: "CreatedDate",
      Value: 0,
      Skip: 0,
      Take: 0,
      Operator: "desc",
      Type: "S",
    },
  ];
  constructor() {
    super();
    this.inputEditorform = ZonePriceAnnouncementFormComponent;
  }

  ngOnInit() {
    this.apiName = "ZonePriceAnnouncement";
    this.areaName = "RestaurantSale";
    this.label = this.translate("ClientApp.Pages.PageMenu.ZonePriceAnnouncement");
    this.unSortableFilterable.push("ZoneTitle");
    this.unSortableFilterable.push("BranchIds");
    this.unSortableFilterable.push("IncreaseRateOfAmount");
    this.unSortableFilterable.push("RoundingAmount");
    this.unSortableFilterable.push("ShamsiDateField");
    this.unSortableFilterable.push("RoundingTypeTitle");
    this.unSortableFilterable.push("AmountTypeTitle");
    this.filters.push({
      Filed: "CreatedDate",
      Value: null,
      Skip: 0,
      Take: 0,
      Operator: "desc",
      Type: "S",
    });
  }
}
